/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timeline_Track_No_Events_VisibleInputs */

const en_timeline_track_no_events_visible = /** @type {(inputs: Timeline_Track_No_Events_VisibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No events visible in current view or no events defined`)
};

const fr_timeline_track_no_events_visible = /** @type {(inputs: Timeline_Track_No_Events_VisibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun evenement visible dans la vue actuelle ou aucun evenement defini`)
};

const de_timeline_track_no_events_visible = /** @type {(inputs: Timeline_Track_No_Events_VisibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In der aktuellen Ansicht sind keine Ereignisse sichtbar oder es sind keine Ereignisse definiert.`)
};

const it_timeline_track_no_events_visible = /** @type {(inputs: Timeline_Track_No_Events_VisibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun evento visibile nella vista corrente o nessun evento definito`)
};

const ru_timeline_track_no_events_visible = /** @type {(inputs: Timeline_Track_No_Events_VisibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В текущем представлении события не отображаются или события не определены`)
};

const es_timeline_track_no_events_visible = /** @type {(inputs: Timeline_Track_No_Events_VisibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay eventos visibles en la vista actual o no hay eventos definidos`)
};

const zh_cn2_timeline_track_no_events_visible = /** @type {(inputs: Timeline_Track_No_Events_VisibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当前视图中未显示任何事件，或未定义任何事件。`)
};

const ja_timeline_track_no_events_visible = /** @type {(inputs: Timeline_Track_No_Events_VisibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在のビューにイベントが表示されていないか、イベントが定義されていません`)
};

const hi_timeline_track_no_events_visible = /** @type {(inputs: Timeline_Track_No_Events_VisibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्तमान दृश्य में कोई घटनाएँ दिखाई नहीं दे रही हैं या कोई घटनाएँ परिभाषित नहीं हैं`)
};

const pt_pt2_timeline_track_no_events_visible = /** @type {(inputs: Timeline_Track_No_Events_VisibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum evento visível na visualização atual ou nenhum evento definido.`)
};

/**
* | output |
* | --- |
* | "No events visible in current view or no events defined" |
*
* @param {Timeline_Track_No_Events_VisibleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_track_no_events_visible = /** @type {((inputs?: Timeline_Track_No_Events_VisibleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Track_No_Events_VisibleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timeline_track_no_events_visible(inputs)
	if (locale === "de") return de_timeline_track_no_events_visible(inputs)
	if (locale === "it") return it_timeline_track_no_events_visible(inputs)
	if (locale === "ru") return ru_timeline_track_no_events_visible(inputs)
	if (locale === "es") return es_timeline_track_no_events_visible(inputs)
	if (locale === "zh-CN") return zh_cn2_timeline_track_no_events_visible(inputs)
	if (locale === "ja") return ja_timeline_track_no_events_visible(inputs)
	if (locale === "hi") return hi_timeline_track_no_events_visible(inputs)
	if (locale === "pt-PT") return pt_pt2_timeline_track_no_events_visible(inputs)
	return en_timeline_track_no_events_visible(inputs)
});